<template>
    <div class="container">
        <img class="img" src="../../assets/tianmi/banner.png" @click="goCivilization" />
        <div class="wrap_flex" style="margin-top: 10px">
            <!-- 帮助与咨询 -->
            
            <div class="img_wrap" @click="goAccount">
                <img class="img_icon" src="../../assets/tianmi/icon_account.png" />
                <span class="img_title">账号问题</span>
            </div>
            <div class="img_wrap" @click="goCertify">
                <img class="img_icon" src="../../assets/tianmi/icon_certify.png" />
                <span class="img_title">认证问题</span>
            </div>
            <div class="img_wrap" @click="goFunction">
                <img class="img_icon" src="../../assets/tianmi/icon_ofen.png" />
                <span class="img_title">功能问题</span>
            </div>
            <div class="img_wrap" @click="goRecharge">
                <img class="img_icon" src="../../assets/tianmi/icon_coin.png" />
                <span class="img_title">充值问题</span>
            </div>
            <!-- <div class="img_wrap">
                <img class="img_icon" src="../../assets/tianmi/icon_point.png" />
                <span class="img_title">积分问题</span>
            </div> -->

          
            <div class="img_wrap" @click="goMore">
                <img class="img_icon" src="../../assets/tianmi/icon_more.png" />
                <span class="img_title">更多问题</span>
            </div>
            <!-- <div class="img_wrap">
                <img class="img_icon" src="../../assets/tianmi/icon_safe.png" />
                <span class="img_title">安全问题</span>
            </div> -->
        </div>

        <div class="wrap" style="margin-top: 10px">
            <div class="wrap_title">
                <div class="title_dot"></div>
                <span style="margin-left: 6px; font-weight: 400; font-size: 17px;">常见问题</span>

                <!-- <div style="flex: 1; background-color: green;"></div> -->
                <!-- <span style="margin-right: 20px; font-weight: 500; font-size: 17px; color: #4169E1" @click="goSample">【防骗指南】</span> -->
            </div>

            <div class="content_wrap">
                <div @click="onPress(1)" class="p_title">
                    <span class="title_text">为什么需要货币才能聊天？</span>
                    <span style="flex:1"></span>
                    <img v-if="question1" class="title_arrow" src="../../assets/warning/ic_open.png" />
                    <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
                </div>
                <div v-if="question1" class="p_content">
                    <div class="line"></div>
                    为了营造良好诚信的交友环境，也为了避免用户被过度骚扰，平台采取消耗货币的聊天交友模式，为有交友需求的用户双方搭建聊天互动的桥梁，秉持平台中立性的原则，聊天扣费权限完全交由用户自主设置。平台有相应免费权益，用户可通过每日签到、完成任务等途径获得免费金币进行聊天交友，双方互相关注文字聊天也是免费的哟~
                </div>
            </div>

            <div class="content_wrap">
                <div @click="onPress(2)" class="p_title">
                    <span class="title_text">如何获得聊天货币？</span>
                    <span style="flex:1"></span>
                    <img v-if="question2" class="title_arrow" src="../../assets/warning/ic_open.png" />
                    <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
                </div>
                <div v-if="question2" class="p_content">
                    <div class="line"></div>
                    <nav style="margin-top: 12px"></nav>
                    1、通过每日签到领取；
                    <nav style="margin-top: 4px"></nav>
                    2、通过完成新手任务、每日任务获得相应金币及道具；
                    <nav style="margin-top: 4px"></nav>
                    3、轻松充值，快速获得；
                </div>
            </div>

            <div class="content_wrap">
                <div @click="onPress(3)" class="p_title">
                    <span class="title_text">聊天双方都要扣费吗？</span>
                    <span style="flex:1"></span>
                    <img v-if="question3" class="title_arrow" src="../../assets/warning/ic_open.png" />
                    <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
                </div>
                <div v-if="question3" class="p_content">
                    <div class="line"></div>
                    当用户设置聊天需付费时，由首次主动发起聊天的一方扣除金币，被动方无需扣除金币（缘分天使发起的聊天为系统牵线消息，回复即为主动方），双方互相关注文字聊天免费。
                </div>
            </div>

            <div class="content_wrap">
                <div @click="onPress(4)" class="p_title">
                    <span class="title_text">聊天过程中可以给私人联系方式吗？</span>
                    <span style="flex:1"></span>
                    <img v-if="question4" class="title_arrow" src="../../assets/warning/ic_open.png" />
                    <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
                </div>
                <div v-if="question4" class="p_content">
                    <div class="line"></div>
                    基于对用户个人隐私安全的保护，双方初识阶段，平台不提倡双方发送私人联系方式信息，双方亲密度达到3级，彼此可根据个人意愿发送11位纯数字。
                </div>
            </div>

            <div class="content_wrap">
                <div @click="onPress(5)" class="p_title">
                    <span class="title_text">如何让异性看到自己并和自己聊天？</span>
                    <span style="flex:1"></span>
                    <img v-if="question5" class="title_arrow" src="../../assets/warning/ic_open.png" />
                    <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
                </div>
                <div v-if="question5" class="p_content">
                    <div class="line"></div>
                    为保障交友真实性，建议用户通过真人认证，来提高资料真实度，完善个人资料信息，来提升交友诚意度，资料越完整，曝光度也会随之提升哟！
                </div>
            </div>




            <div class="content_wrap">
                <div @click="onPress(6)" class="p_title">
                    <span class="title_text">为什么发消息提示我违规？</span>
                    <span style="flex:1"></span>
                    <img v-if="question6" class="title_arrow" src="../../assets/warning/ic_open.png" />
                    <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
                </div>
                <div v-if="question6" class="p_content">
                    <div class="line"></div>
                    平台设有风控管理机制，如用户发送的信息内容涉及违禁用词，系统会提示无法发送，具体以系统判定提示为准，请广大用户规范聊天，礼貌交友。
                </div>
            </div>

            <div class="content_wrap">
                <div @click="onPress(7)" class="p_title">
                    <span class="title_text">如何邀请好友来玩？</span>
                    <span style="flex:1"></span>
                    <img v-if="question7" class="title_arrow" src="../../assets/warning/ic_open.png" />
                    <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
                </div>
                <div v-if="question7" class="p_content">
                    <div class="line"></div>
                    进入邀请活动页面，复制邀请码并点击“立即邀请”按键将邀请海报分享至好友，好友注册时填入您的邀请码，双方邀请关系绑定成功。具体奖励规则及邀请记录可在邀请页面进行查看。
                </div>
            </div>

            

        <div style="margin-bottom: 100px">
        </div>

        </div>

        <div class="kefu" @click="kefu">
            <span style="font-size: 16px; color: white;">联系在线客服</span>
            <img v-if="isVip" class="kefu_vip" src="./imgs/icon_vip.png" />
        </div>


        <div v-if="!showInfo" style="width: 100vw; height: 100vh; position: fixed; background-color: white;"></div>
    </div>
</template>


<script>
import { sha256_digest } from '../../common/sha256';
import { IMG_COMMON, IMG_FAQ_1, IMG_FAQ_2, IMG_FAQ_3, IMG_FAQ_4, IMG_FAQ_5 } from './consts';

export default {
    data() {
        return {
            question1: false,
            question2: false,
            question3: false,
            question4: false,
            question5: false,
            question6: false,
            question7: false,
            question8: false,
            question9: false,
            question10: false,
            question11: false,

            question12: false,  // 付费规则
            question13: false,  // 联系方式成功发送标准
            question14: false,  // 发地址为什么对方看不到

            id: '',
            name: '',
            // gender: '',
            isCheck: false,
            hideButton: '',
            pay: 0,
            complain: 0,
            complainId: 0,
            isVip: false,

            imgs: [],
            isFemale: false,
            gender: 0,

            showInfo: false
        }
    },

    created() {
        const url = window.location.href;
        const z = url.split('?');
        let p = {};
        let goKeFuDirect = false;

        try {
            const k = z[1].split('&');
            k.forEach(item => {
                const m = item.split('=');
                p[m[0]] = m[1];
            })
            this.id = p.id;
            this.name = p.name;
            // this.hideButton = p.gender == 2 && p.isCheck == 0;
            this.hideButton = false;
            this.isCheck = p.isCheck == 1;
            this.pay = p.pay == undefined ? -1 : p.pay;
            this.complain = p.complain == 1;
            this.complainId = p.complainId;
            this.isVip = p.vip > 0;
            goKeFuDirect = p.kefu == 1;

            if (p.gender == 1 || p.gender == 2) {
                this.gender = p.gender;
            }
        } catch(e) {}

        this.imgs = IMG_FAQ_5;
        // console.log('var si - - - -- - - ->', this.id, this.name, this.showServiceButton);
        if (goKeFuDirect) {
            this.kefu();
        } else {
            this.showInfo = true;
        }
    },

    mounted() {
        
    },

    methods: {
        onPress(value) {
            // console.log('value si htis- - - - - - - - >', value);
            switch(value) {
                case 1:
                    this.question1 = !this.question1;
                    break;

                case 2:
                    this.question2 = !this.question2;
                    break;

                case 3:
                    this.question3 = !this.question3;
                    break;

                case 4:
                    this.question4 = !this.question4;
                    break;

                case 5:
                    this.question5 = !this.question5;
                    break;

                case 6:
                    this.question6 = !this.question6;
                    break;

                case 7:
                    this.question7 = !this.question7;
                    break;

                case 8:
                    this.question8 = !this.question8;
                    break;

                case 9:
                    this.question9 = !this.question9;
                    break;

                case 10:
                    this.question10 = !this.question10;
                    break;
                
                case 11:
                    this.question11 = !this.question11;
                    break;

                case 12:
                    this.question12 = !this.question12;
                    break;

                case 13:
                    this.question13 = !this.question13;
                    break;

                case 14:
                    this.question14 = !this.question14;
                    break;

                default:
                    break;
            }
        },

        kefu() {
            let url = '';
            if (this.id && this.id != "null") {
                const nonce = 189823;
                const ts = (new Date()).getTime();
                const web_token = `${this.id}`;
                const key = 'de2099f7864d03102b3a2fdd4369d1b4';
                let sign_str = `nonce=${nonce}&timestamp=${ts}&web_token=${web_token}&${key}`;
                sign_str = sha256_digest(sign_str);
                sign_str = sign_str.toUpperCase();
                const complain = this.complain ? `[投诉:${this.complainId}]_` : '';
                const pay = this.pay != -1 ? `[¥:${this.pay}]_` : '';
                const check = this.isCheck ? `[审核人员]_` : '';
                const gender = this.checkGender();

                const cName = `${check}${complain}${pay}${this.name}_id:${this.id}${gender}`;
                // console.log('cName ish tis- - - - -- ->', cName);
                url = `https://1894876.s4.udesk.cn/im_client/?web_plugin_id=32596&nonce=${nonce}&timestamp=${ts}&web_token=${web_token}&signature=${sign_str}&encryption_algorithm=SHA256&c_name=${cName}`;
            } else {
                url = `https://1894876.s4.udesk.cn/im_client/?web_plugin_id=32596&`;
            }
            // console.log('url si hti - - - --  ->', url);
            window.location.href = url;
        },

        checkGender() {
            let str = "";
            switch(this.gender) {
                case "1":
                    str = "_男";
                    break

                case "2":
                    str = "_女";
                    break;
                        
                default:
                    break;
            }
            return str;
        },

        goSample() {
            window.location.href = '/warning-sample';
        },

        goCivilization() {
            window.location.href = '/faq-tm-civilization';
        },

        goAccount() {
            window.location.href = '/faq-tm-account';
        },

        goCertify() {
            window.location.href = '/faq-tm-certify';
        },

        goFunction() {
            window.location.href = '/faq-tm-function';
        },

        goRecharge() {
            window.location.href = '/faq-tm-recharge';
        },

        goMore() {
            window.location.href = '/faq-tm-more';
        }
    }
}
</script>


<style scoped>
.container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #FFF8F8FF;
}
.wrap {
    width: 94vw;
    margin-left: 3vw;
    background-color: #FFF;
    border-radius: 15px;
    margin-top: 0vw;
}
.wrap_title {
    display: flex;
    width: 94vw;
    height: 30px;
    margin-top: 10px;
    align-items: center;
    /* background-color: pink; */
}
.title_dot {
    margin-left: 24px;
    width: 2px; 
    height: 14px; 
    border-radius: 4px;
    background-color: #7678FF
}

.content_wrap {
    width: 90vw;
    padding-top: 10px;
    padding-bottom: 10px;
    margin: 4px 10px 4px 8px;
    border-bottom: 0.2px solid #F5F5F5;
}
.p_title {
    font-size: 16px;
    font-weight: 600px;
    margin: 0px 20px 0px 20px;
    align-items: center;
    /* background-color: #FF0000; */
    /* border-bottom-width: 100px; */
    /* border: 1px solid; */
    /* border-bottom-color: #FF0000; */
    display: flex;
    color: #333;
}
.title_icon {
    width: 26px;
    height: 26px;
}
.title_icon_l {
    margin-left: -3px;
    width: 31px;
    height: 31px;
}
.title_arrow {
    width: 12px;
    height: 12px;
}
.title_text {
    font-size: 14px;
}

.p_content {
    font-size: 15px;
    font-weight: 300px;
    margin: 4px 30px;
    color: #AAA;
}
.content_desc {
    font-size: 16px;
    font-weight: 400px;
}

.img {
    width: 94vw;
    height: 26.6vw;
    margin-top: 10px;
    margin-left: 3vw;
}
.line {
    height: 1px;
    background-color: #EEE;
    margin: 6px 0px;
}

.kefu {
    position: fixed;
    display: flex;
    bottom: 20px;
    left: 10vw;
    width: 80vw;
    height: 48px;
    border-radius: 10px;
    align-items: center;
    background-color: red;
    background: -webkit-linear-gradient(
        left, #CEAFFE, #7384FF
    );
    justify-content: center;
}
.kefu_vip {
    position: absolute;
    top: 1vw;
    right: 2vw;
    width: 6vw;
    height: 6vw;
    object-fit: contain;
}



.wrap_flex {
    width: 94vw;
    margin-left: 3vw;
    padding-bottom: 10px;
    background-color: #FFF;
    border-radius: 15px;
    display: flex;
    flex-wrap: wrap;
}
.img_icon {
    width: 21vw;
    height: 21vw;
}
.img_wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 23.5vw;
    height: 25vw;
}
.img_title {
    font-size: 12px;
    margin-top: -6px;
}
</style>